import Cookies from "js-cookie";
import amplitude from "../amplitude";
import { Platform } from "gather-common/dist/src/public/constants";
import WebWorkerClient from "../worker/WebWorkerClient";
import { event as gtagEvent } from "./gtag";
import { runOnNextIdleCb } from "../lazyScheduler";
import { isElectron, isMobile } from "../userAgent";
const cookieName = "amplitudeCookie";
export const metricsUtilsDataSource = {
    getDefaultDeviceId: async () => Cookies.get(cookieName),
    getDeviceId: () => amplitude.getDeviceId(),
    getPlatform: () => isElectron ? Platform.DesktopApp : isMobile ? Platform.MobileWeb : Platform.DesktopWeb,
    gtagEvent: (...args) => gtagEvent(...args),
    onDeviceId: (deviceId) => {
        Cookies.set(cookieName, deviceId, {
            expires: 3650,
            domain: "gather.town",
        });
    },
    runOnNextIdleCb: (...args) => runOnNextIdleCb(...args),
    groupIdentify: (...args) => WebWorkerClient.amplitude.groupIdentify(...args),
    identify: (...args) => WebWorkerClient.amplitude.identify(...args),
    logEvent: (...args) => WebWorkerClient.amplitude.logEvent(...args),
    setDeviceId: (...args) => WebWorkerClient.amplitude.setDeviceId(...args),
    setGroup: (...args) => WebWorkerClient.amplitude.setGroup(...args),
    setUserId: (...args) => WebWorkerClient.amplitude.setUserId(...args),
};
//# sourceMappingURL=MetricsUtilsDataSource.js.map